<ng-container class="report-custom-container">
    <app-report-select [title]="'Reporte combinado de Deudas agudos/adelantos/pedidos y RE/PRM'"
        (previewClicked)="handlePreviewClick()" (printClicked)="handlePrintClick()" (pdfClicked)="handlePdfClick()"
        (excelClicked)="handleExcelClick()">
        <div slot="content" class="container-options">
            <form [formGroup]="form">
                <section class="filter-container" *ngIf="typeGlobal" >
                    <div class="subtitle">Institución</div>
                    <app-form-field
                      class="field"
                      [type]="'select'"
                      label="Seleccione la institución"
                      [fieldControl]="form.controls['selectedInstitution'] | asFormControl"
                      [options]="selectOptionsInsitutions">
                    </app-form-field>
                </section>

                <section class="filter-container">
                    <p class="subtitle">Agrupar por</p>
                    <mat-checkbox formControlName="checkboxDoctorSS">
                        MedicoSS
                    </mat-checkbox>
                </section>
            </form>
        </div>
    </app-report-select>
</ng-container>
